/**
 * [View all supported countries](https://github.com/sumup-oss/intl-js/blob/main/src/data/currencies.ts).
 */
export enum EnumCurrency {
  GTQ = 'GTQ', // Quetzal
  USD = 'USD', // Dolar
  EUR = 'EUR' // Euro
}

export enum EnumIBANCurrency {
  GTQ = 1, // Quetzal
  USD = 2, // Dolar
  EUR = 28 // Euro
}

export const DEFAULT_CURRENCY = {
  code: EnumCurrency.GTQ,
  symbol: 'Q',
  name: 'QUETZAL',
  plural: 'QUETZALES'
}

export const CATALOG_CURRENCIES = [
  {
    code: EnumCurrency.GTQ,
    dbOld: '6580613157e3e1ad0cc36471',
    name: 'QUETZALES',
    other: {
      default: 'QUETZAL',
      feic: 'QUETZALES'
    },
    cents: {
      default: 'Centavo de Quetzal',
      feic: 'Centavos de Quetzal'
    },
    symbol: {
      default: 'Q',
      feic: 'GTQ'
    }
  },
  {
    code: EnumCurrency.USD,
    dbOld: '6580f432a734517993de3258',
    name: 'DOLARES',
    other: {
      default: 'DOLAR',
      feic: 'DOLARES'
    },
    cents: {
      default: 'Centavo de Dólar',
      feic: 'Centavos de Dólar'
    },
    symbol: {
      default: '$',
      feic: 'USD'
    }
  },
  // Estuvo comentado y se reactivó: producción tiene DOS clientes vivos con
  // cuentas en Banco Sabadell (IBAN español, saldos de seis cifras) declaradas en
  // euros. Con el euro apagado, el primer asesor que abriera uno de esos
  // expedientes y guardara cualquier cosa pisaba una declaración patrimonial de
  // compliance sin enterarse. Es moneda DECLARABLE —lo que un cliente dice tener
  // en otro banco—, no una moneda en la que la empresa cotice: los precios siguen
  // en GTQ/USD (ver `MONEY_CURRENCIES` en @idc-forms/schemas).
  {
    code: EnumCurrency.EUR,
    name: 'EUROS',
    other: {
      default: 'EURO',
      feic: 'EUROS'
    },
    cents: {
      default: 'Céntimo de Euro',
      feic: 'Céntimos de Euro'
    },
    symbol: {
      default: '€',
      feic: 'EUR'
    }
  }
]
